<template>
    <div id="fs5-instant-commissions">
        <div class="header" v-html="view.t.instant_commissions"></div>
        <fs5-get-paid-collapse v-if="view.video.status"
            :view="{
                title: view.t.btn_tool_tutorials,
                nameCollapse: 'statusCollapseEarns'+view.user.id,
                content: {
                    translation:{
                        header: [view.t.label_tutorial+' 01'],
                        coming_soon: view.video.tutorial
                    },
                    urls: view.video.tutorial
                }
            }">
            <div :slot="'content'" slot-scope="props">
                <fs5-get-paid-tutorial :view="props.content"></fs5-get-paid-tutorial>
            </div>
        </fs5-get-paid-collapse>
        <br>
        <div class="content">
            <p class="subtitle-content color-secondary to-uppercase" v-html="view.t.instant_commissions_label_1"></p>
            <div class="box-content">
                <div class="box-content-1">
                    <p class="content-p line-height" v-html="view.t.instant_commissions_label_rule"></p>
                    <p class="content-p line-height" v-html="view.t.instant_commissions_label_2"></p>
                </div>
                <div class="box-content-2">
                    <p class="subtitle-content color-dark" v-html="view.t.instant_commissions_label_3"></p>
                    <fs5-button
                        :label="view.t.gateway_paypal"
                        :text-transform-type="'capitalize'"
                        @clicked="open(0)"
                        :icon="'/internacional/public/office5/img/franchise_dashboard/svg/'+ (statusPayPal ? 'paypal-dark' : 'paypal') +'.svg'"
                        :btn-type="!statusPagSeguro && statusPayPal ? '' : 'primary'"
                        :disabled="statusPayPal"
                        :title="view.t.gateway_paypal"
                    ></fs5-button>
                    <br>
                    <fs5-button
                        v-if="view.is_subsidiary_br"
                        :label="view.t.gateway_pagseguro"
                        :text-transform-type="'capitalize'"
                        @clicked="open(1)"
                        :icon="'/internacional/public/office5/img/franchise_dashboard/svg/'+ (statusPagSeguro ? 'pagseguro-dark' : 'pagseguro') +'.svg'"
                        :btn-type="!statusPayPal && statusPagSeguro ? '' : 'primary'"
                        :disabled="statusPagSeguro"
                        :title="view.t.gateway_pagseguro"
                    ></fs5-button>
                </div>
            </div>
        </div>
        <div v-if="showSpinner" class="load-spinner">
            <spring-spinner :animation-duration="2000" :size="50" color="#0080fc"/>
        </div>
        <div v-if="(statusPayPal || statusPagSeguro) && !showSpinner" class="content-gateway">
            <div class="title-gateway" v-html="statusPayPal ? view.t.gateway_paypal : view.t.gateway_pagseguro"></div>
            <div class="box-gateway">
                <div v-if="statusPayPal" class="box-gateway-1">
                    <p class="content-p margin-bottom">{{ view.t.access_paypal }} <a href="https://paypal.com" target="_blank">https://paypal.com</a></p>
                    <p class="content-p margin-bottom" v-html="view.t.access_paypal_2"></p>
                    <p class="content-p margin-bottom" v-html="view.t.warning_receivement_gateways"></p>
                    <p class="atention-p font-lato" v-html="view.t.instant_commissions_label_refund"></p>
                </div>
                <div v-if="statusPagSeguro" class="box-gateway-1">
                    <p class="subtitle-content color-dark to-uppercase margin-bottom" v-html="view.t.br_exclusive_receivement_gateway"></p>
                    <p class="content-p margin-bottom">{{ view.t.access_pagseguro }} <a href="https://pagseguro.uol.com.br" target="_blank">https://pagseguro.uol.com.br</a></p>
                    <ol class="list-content">
                        <li class="content-p item-list" v-html="view.t.access_pagseguro_2"></li>
                        <li class="content-p item-list" v-html="view.t.access_pagseguro_3"></li>
                        <li class="content-p item-list" v-html="view.t.access_pagseguro_4"></li>
                    </ol>
                    <p class="content-p margin-bottom" v-html="view.t.access_pagseguro_5"></p>
                    <p class="content-p margin-bottom" v-html="view.t.warning_receivement_gateways"></p>
                    <p class="atention-p font-lato" v-html="view.t.instant_commissions_label_refund"></p>
                </div>
                <div class="box-gateway-2 flex-column">
                    <p class="subtitle-content color-dark to-uppercase" v-html="view.t.enter_your_data"></p>
                    <div class="flex-column">
                        <label for="indentificator" class="color-dark" v-html="view.t.receivement_gateways_identifier"></label>
                        <input @keyup.enter="validateForm()" type="text" id="indentificator" :class="['input-data-user',stateFilterIndentifier ? 'success-input' : 'error-input']" v-model="gatewayIdentifier" placeholder="Ex: builderall@empresa.com.br">
                        <span v-if="!stateFilterIndentifier" class="error-message" v-html="view.t.receivement_gateways_invalid_identifier"></span>
                    </div>
                    <div class="flex-column" v-if="statusPagSeguro">
                        <label for="token" class="color-dark" v-html="view.t.receivement_gateways_token"></label>
                        <input @keyup.enter="validateForm()" type="text" id="token" :class="['input-data-user', stateFilterToken ? 'success-input' : 'error-input']" v-model="gatewayToken" :placeholder="view.t.receivement_gateways_token">
                        <span v-if="!stateFilterToken" class="error-message" v-html="view.t.receivement_gateways_invalid_token"></span>
                    </div>
                    <div class="box-btn-save">
                        <fs5-button
                            class="btn-save to-uppercase"
                            :label="view.t.button_salvar"
                            :text-transform-type="'capitalize'"
                            @clicked="validateForm()"
                            :btn-type="'primary'"
                            :disabled="statusPagSeguro ? (stateFilterToken && stateFilterIndentifier ? false : true) : (stateFilterIndentifier ? false : true)"
                        ></fs5-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import qs from "qs";
import { SpringSpinner } from 'epic-spinners'
    export default {
        name: 'fs5-instant-commissions',
        props: ['view'],
        components: {
            'spring-spinner': SpringSpinner
        },
        data() {    
            return {  
                statusPayPal: false,
                statusPagSeguro: false,
                stateFilterIndentifier: false,
                existsErrorToken: false,
                showSpinner: false,
                gatewayIdentifier: '', 
                gatewayToken: '', 
            }
        },
        methods: {
            open(data)
            {
                this.gatewayIdentifier = '';
                this.gatewayToken = '';
                if(data == 0)
                {
                    if(!this.statusPagSeguro && this.statusPayPal)
                    {
                        // close paypal
                        this.statusPayPal = false;
                    }
                    else
                    {
                        // open paypal
                        this.statusPayPal = true;
                        this.statusPagSeguro = false;
                    }
                    this.gatewayIdentifier = this.view.paypal_identifier;
                    this.gatewayToken = '';
                }
                if(data == 1)
                {
                    if(!this.statusPayPal && this.statusPagSeguro)
                    {
                        // close pagseguro
                        this.statusPagSeguro = false;
                    }
                    else
                    {
                        // open pagseguro
                        this.statusPagSeguro = true;
                        this.statusPayPal = false;
                    }
                    this.gatewayIdentifier = this.view.pagseguro_identifier;
                    this.gatewayToken = this.view.pagseguro_token;
                }
            },
            makeRequest()
            {
                this.showSpinner = true;
                let dataParameters = { 
                    'identifier': this.gatewayIdentifier,
                    'token': this.gatewayToken,
                    'type': this.statusPagSeguro ? 'pagseguro' : 'paypal'
                };
                axios
                    .post(this.view.route_send, qs.stringify(dataParameters))
                    .then((response) => {
                        if(response.data.success)
                        {
                            if(!this.statusPayPal)
                            {
                                this.view.pagseguro_identifier = this.gatewayIdentifier;
                                this.view.pagseguro_token = this.gatewayToken;
                            }
                            else
                            {
                                this.view.paypal_identifier = this.gatewayIdentifier;
                            }
                            this.showToast('success',this.view.t.alterado_com_sucesso);
                            this.handleSuccess();
                        }
                        else
                        {
                            $.alert({
                                title:   this.view.t.dns_error,
                                content: response.data.error,
                                type:    'red'
                            });
                        }
                        this.showSpinner = false;
                    })
                    .catch(e => {this.showSpinner = false,this.showToast('error',this.view.t.ocorreu_erro)});
            },
            handleSuccess(){
                const queryString = window.location.search;
                const urlParams   = new URLSearchParams(queryString);

                let redir = urlParams.get('redir');

                if(redir){
                    urlParams.delete('redir');
                    urlParams.delete('open-modal');

                    let params = urlParams.toString();
                    let url = redir;

                    if(params){
                        url = url + '?' + params;
                    }

                    window.location.href = url;
                }
            },
            showToast(type,data)
            {
                alertMsg(type,data);
            },
            validateForm()
            {
                // for two validation camps
                let isValid = [true,true];

                // remove classes
                $('#indentificator').removeClass('error-input');
                $('#token').removeClass('error-input');

                // validations
                if(!this.gatewayIdentifier || !this.stateFilterIndentifier)
                {
                    // apply error classes
                    $('#indentificator').addClass('error-input');
                    isValid[0] = false;
                }
                else
                {
                    // remove error classes
                    $('#indentificator').removeClass('error-input');
                }

                if(this.statusPagSeguro)
                {
                    if(!this.gatewayToken || !this.stateFilterToken)
                    {
                        // apply error classes
                        $('#token').addClass('error-input');
                        this.existsErrorToken = true;
                        isValid[1] = false;
                    }
                    else
                    {
                        // remove error classes
                        $('#token').removeClass('error-input');
                        this.existsErrorToken = false;
                    }
                }

                // call the methods
                if(isValid[0] && isValid[1])
                {
                    this.makeRequest();
                }
                else
                {
                    let errorMessage;
                    if(!isValid[0] && !isValid[1])
                    {
                        errorMessage = this.view.t.error_report_identifier_token;

                    }
                    else if(!isValid[0])
                    {
                        errorMessage = this.view.t.error_report_identifier;
                    }
                    else 
                    {
                        errorMessage = this.view.t.error_report_token;
                    }
                    this.showToast('error',errorMessage)
                }
            }
        },
        watch: {
            gatewayIdentifier()
            {
                // Removing spaces from the string and performing a validation
                if(!this.gatewayIdentifier == false)
                {
                    if(this.gatewayIdentifier.indexOf(' ') != -1)
                    {
                        let dataValue = this.gatewayIdentifier.replace(/\s/g, '');
                        this.gatewayIdentifier = dataValue;
                    }
                    let max = this.gatewayIdentifier.length;
                    let positionItem1 = this.gatewayIdentifier.indexOf('@');
                    let positionItem2 = this.gatewayIdentifier.indexOf('.');
                    if(positionItem1 != -1 && positionItem2 != -1)
                    {
                        if(max-1 > positionItem1 && max-1 > positionItem2)
                        {
                            this.stateFilterIndentifier = true;
                            return;
                        } 
                    }
                }
                this.stateFilterIndentifier = false;
            },
            gatewayToken()
            {
                // Removing spaces from the string and performing a validation
                if(!this.gatewayToken == false)
                {
                    if(this.gatewayToken.indexOf(' ') != -1)
                    {
                        let value = this.gatewayToken.replace(/\s/g, '');
                        this.gatewayToken = value;
                    }
                    if(this.gatewayToken.length == 32 || this.gatewayToken.length == 100)
                    {
                        this.stateFilterToken = true;
                        return;
                    }
                }
                this.stateFilterToken = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../scss/extras/_variables'; // see fonts and colors with prefix $fs5
    #fs5-instant-comissions {
        font-family: $fs5-font2;
    }
    .header{
        color: $fs5-color11;
        line-height: 1.2;
        font-weight: 900;
        font-size: 2em;
        margin-bottom: 0.7em;
        text-transform: uppercase;
    }
    .content{
        background: $fs5-color2;
        padding: 3em;
        border-radius: 8px;
        border: 1px solid $fs5-color1;
        .box-content{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding-top: 1em;
            .box-content-1{
                width: 50%;
            }
            .box-content-2{
                width: 40%;
            }
        }
    }
    .load-spinner{
        display: flex;
        justify-content: center;
        padding: 2em;
    }

    .subtitle-content {
        font-size: 1.2em;
        font-family: Lato;
        font-weight: bold;
    }

    .content-p{
        font-size: 1.1em;
    }

    .margin-bottom{
        margin-bottom: 1em;
    }

    .font-lato{
        font-family: Lato;
    }

    .line-height{
        line-height: 1.2em;
    }

    .color-secondary{
        color: $fs5-color-24;
    }

    .color-dark{
        color: $fs5-color4;
    }

    .to-uppercase{
        text-transform: uppercase;
    }

    .flex-column{
        display: flex;
        flex-direction: column;
    }
    
    .content-gateway{
        background: $fs5-color2;
        margin-top: 2em;
        border: 1px solid $fs5-color1;
        border-radius: 8px;
        justify-content: center;
        .title-gateway{
            padding: 0.5em 0 0.5em;
            background: $fs5-color3;
            color: $fs5-color2;
            font-size: 1.5em;
            font-weight: bold;
            border-radius: 8px 8px 0 0;
            text-align: center;
        }
        .box-gateway{
            display: flex;
            flex-direction: row;
            .box-gateway-1,
            .box-gateway-2{
                width: 50%;
                padding: 2em;
            }
            .box-gateway-1{
                .list-content{
                    margin: 2em;
                    .item-list{
                        margin: 0.6em;
                    }
                }
            }
            .box-gateway-2{
                border-left: 1px solid $fs5-color1;
                gap: 5%;
                .input-data-user {
                    padding: 1em;
                    border-radius: 8px;
                    border: 1px solid $fs5-color25;
                    letter-spacing: 1px;
                    outline: none;
                    transition: .5s;
                }
                .success-input{
                    border: 1px solid $fs5-color16 !important;
                }
                .error-input{
                    border: 1px solid $dv5-color11 !important;
                }
                .error-message{
                    color: $dv5-color11;
                }
                .box-btn-save{
                    display: flex;
                    justify-content: right;
                    .btn-save{
                        width: 35%;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 660px) {
        .content{
            .box-content{
                flex-direction: column;
                column-gap: 5%;
                .box-content-1,
                .box-content-2{
                    width: 100%;
                }
            }
        }
        .content-gateway{
            .box-gateway{
                flex-direction: column;
                .box-gateway-1,
                .box-gateway-2{
                    width: 100%;
                }
                .box-gateway-2{
                    border-left: none;
                    .box-btn-save{
                        padding: 1em 0;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/instant_commissions/index.vue